// extracted by mini-css-extract-plugin
export default {"form":"TranslateProgramCategoryForm_form__HPmqk"};